import { WorkspaceInvite } from "@/types/workspace-invite";
import { useMemo } from "react";

export function useInvitesByOrg(invites: WorkspaceInvite[]) {
  return useMemo(() => {
    return invites.reduce<Record<number, WorkspaceInvite[]>>((map, invite) => {
      const orgId = invite.workspace.organization_id;
      if (!map[orgId]) map[orgId] = [];
      map[orgId].push(invite);
      return map;
    }, {});
  }, [invites]);
}
